import { render } from "./ThanksPointNoGifts.vue?vue&type=template&id=6298de6a&scoped=true&ts=true"
import script from "./ThanksPointNoGifts.vue?vue&type=script&lang=ts"
export * from "./ThanksPointNoGifts.vue?vue&type=script&lang=ts"

import "./ThanksPointNoGifts.vue?vue&type=style&index=0&id=6298de6a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6298de6a"]])

export default __exports__